import find from 'lodash/find';
import get from 'lodash/get';

import { routes } from '../routes';
import { fetch, json } from './fetch'

declare const global: any;
// hasWindow = true for tests + client
export const hasWindow = typeof window !== 'undefined';

// isBrowser = true for client only
export const isBrowser = __CLIENT__

export const localUrl = isBrowser
  ? get(window, 'location.origin')
  : `http://localhost:${process.env.PORT}`;

export function findRoute(pathname) {
  return find(routes, (route) =>
              pathname.replace(/(\?.*)|(#.*)/g, '').startsWith(route.path)
  );
}

export function findRoutes(router) {
    return find(routes, (route) => router.isActive(route.path, true));
  // return find(routes, (route) =>
  //             pathname.replace(/(\?.*)|(#.*)/g, '').startsWith(route.path)
  //);
}

export function hasRoute(routes, route) {
  return find(routes, (r: any) => (r['label'] === route['label'] || r.children && hasRoute(r.children, route)));
}

export function promisify(fn: Function, context = {}): Function {
  return function (...args) {
    return new Promise(function(result, reject) {
      //fn(...args, result);
      fn.apply(context, [...args, result]);
      //      resolve(data)
    });
  };
}

export function pcall(fn, ...args) {
  return promisify(fn)(...args);
}

function C(classes) {
		if (classes) {
				if (classes.map) {
						return classes.map(cls => C(cls)).join('')
				}
				return '.' + classes.split(' ').join('.')
		}
		return ''
}

import * as React from 'react';
const S = C

function purify(statelessComponent) {
	return class PureComponentWrap extends React.PureComponent<any, any> {
		render() {
			return statelessComponent(this.props)
		}
	}
}

import union from 'lodash/union'
import keys from 'lodash/keys'
function shallowEquals(a, b) {
	const allKeys = union(keys(a), keys(b))
	return allKeys.filter(v => a[v] !== b[v]).length === 0
}

export { fetch, json, S, C, purify, shallowEquals }



// WEBPACK FOOTER //
// ./src/app/utils/index.ts